/**
 * Validator for arrays of `{ <refKey>: { id }, weight, sublanders? }` objects.
 * Used by both lander and offer arrays on `path_PathUpdateResource`.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { VOLUUM_PATH_ITEM_WEIGHT_MAX } from '../../voluum-weight.constants';
import {
  describe,
  isPlainObject,
  joinPath,
  pushError,
  requireNumber,
  requireString,
  type ValidationCtx,
} from '../primitives';

export function validateRefList(
  ctx: ValidationCtx,
  v: unknown,
  basePath: string,
  refKey: 'lander' | 'offer',
): void {
  if (!Array.isArray(v)) {
    pushError(ctx, basePath, 'invalid_array', 'Expected array', {
      expected: 'array',
      received: describe(v),
    });
    return;
  }
  v.forEach((entry, idx) => {
    const path = joinPath(basePath, idx);
    if (!isPlainObject(entry)) {
      pushError(ctx, path, 'invalid_object', 'Item must be an object');
      return;
    }
    const w = requireNumber(ctx, entry, 'weight', path);
    if (w !== undefined) {
      if (w < 0 || w > VOLUUM_PATH_ITEM_WEIGHT_MAX) {
        pushError(
          ctx,
          joinPath(path, 'weight'),
          'invalid_value',
          `Weight must be between 0 and ${VOLUUM_PATH_ITEM_WEIGHT_MAX} (Voluum: < 1000)`,
        );
      }
    }
    const refPath = joinPath(path, refKey);
    const ref = entry[refKey];
    if (ref === undefined) {
      pushError(
        ctx,
        refPath,
        'missing_required',
        `Missing required field "${refKey}"`,
      );
    } else if (!isPlainObject(ref)) {
      pushError(ctx, refPath, 'invalid_object', `"${refKey}" must be an object`);
    } else {
      requireString(ctx, ref, 'id', refPath);
    }
    if (refKey === 'lander' && entry.sublanders !== undefined) {
      validateRefList(
        ctx,
        entry.sublanders,
        joinPath(path, 'sublanders'),
        'lander',
      );
    }
  });
}
